'use strict';

var Transport = require('./transport');
var HTTP = require('./_internal/http');
var Fetch = require('./_internal/fetch');

/**
 * Create an instance of Transport
 *
 * @param {module:spotify-transport/types.TransportConfig} config The config
 *     for this instance of Transport.
 * @return {module:spotify-transport/Transport} The created instance
 */
module.exports = function(config) {
  config.HTTP = HTTP;
  config.Fetch = Fetch;
  config.WebSocket = global.WebSocket;

  return Transport.create(config);
};
